// Help text for: Bill Reconciliation tab.
// Keys are referenced as "billReconciliation.<field>" by <FieldHelp id=... />. Entry shape:
//   title  - field name as shown on screen
//   use    - what the field is for / how to read it
//   source - measured | calculated | backend | default | setting | input
//   how    - where the value comes from: formula, default value, or who sets it
const help = {
  recentBill: {
    title: "Recent Bill",
    use: "The total on your latest utility (grid) bill, so you can hold it up against what EnViz measured and what it forecasts.",
    source: "backend",
    how: "The total in Rs. exactly as printed on the paper bill, taken from the most recent bill added to EnViz. Bills are typed in by the Enfo team when they arrive, up to 12 billing months per account. \"For\" tells you which billing month that bill covers.",
  },
  recentBillUnits: {
    title: "Recent Bill Units",
    use: "The units (kWh) you were charged for on your latest utility bill.",
    source: "backend",
    how: "The total units figure as printed on the most recent bill typed into EnViz. It is taken straight off the bill, not added up from the separate peak and off-peak figures. \"For\" tells you which billing month that bill covers.",
  },
  billForecast: {
    title: "Bill Forecast",
    use: "A rough guess at your grid bill for the next 30 days if you keep using power at today's rate.",
    source: "calculated",
    how: "Bill Forecast Units multiplied by your Grid Unit Price (Rs. per kWh, which you set under Settings > Details > Unit Prices). It uses that one flat price only — no fixed charges, no separate peak and off-peak rates, no taxes or surcharges. Shows Rs. 0 until a unit price is set.",
  },
  billForecastUnits: {
    title: "Bill Forecast Units",
    use: "The grid units (kWh) you are likely to bring in over the next 30 days.",
    source: "calculated",
    how: "Daily Avg Usage multiplied by 30. Only the meters marked as GRID that your login can see are counted.",
  },
  dailyAvgUsage: {
    title: "Daily Avg Usage",
    use: "The grid units (kWh) you have brought in per day, on average, since the meter reading on your last bill.",
    source: "calculated",
    how: "The kWh brought in through every GRID meter from your latest bill's reading date up to today, divided by the number of days in between — never fewer than 1. Energy comes from each meter's hourly energy count. If the bill carries no reading date, counting starts on the 1st of this month.",
  },
  billHistory: {
    title: "Bill History",
    use: "The amount in Rs. and the units in kWh for each billing month, with the forecast as the last bar.",
    source: "backend",
    how: "The monthly bars come from the bills typed into EnViz, in the order they were added. The Forecast bar is the Bill Forecast and Bill Forecast Units for the next 30 days — see those cards.",
  },
  billBreakdown: {
    title: "Bill Breakdown",
    use: "How your latest bill splits between energy, fixed charges, taxes and surcharges.",
    source: "backend",
    how: "The amounts exactly as printed on the most recent bill: Energy Cost, Fixed Cost, Qtr. Adj., E-Duty, TV Fee, GST, Income Tax, Extra Tax, Further Tax, FC Surcharge and FPA; anything at zero is hidden. The middle shows the bill total, which also takes in items not drawn here — arrears, meter rent or adjustments — so the slices may not add up to it exactly.",
  },
};

export default help;
